export default __webpack_public_path__ + "static/media/full-logo.a62e6923.png";